module.exports = __webpack_public_path__ + "media/images/gmail-icon-adcd4d758ddf5f31dadbf10b4375f5f5.svg";